import { useMemo } from 'react'

export const useDataProvider = (_resource = '', httpClient) =>
  useMemo(
    () => ({
      get: (path, config) => httpClient.get(path, config),
      create: (path, payload, config) => httpClient.post(path, payload, config),
      update: (path, id, payload, config) =>
        httpClient.put(`${path}/${id}`, payload, config),
      delete: (path, id, config) => httpClient.delete(`${path}/${id}`, config)
    }),
    [httpClient]
  )

export default useDataProvider
